module.exports = __webpack_public_path__ + "static/img/home-img1.87e6d50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img1.png
// module id = Bhy+
// module chunks = 1